import {ListingsAndGroups, Text, VStack} from "@hosttools/frontend";
import type {Listing} from "@hosttools/frontend/models/listing";
import type React from "react";
import {memo, useCallback} from "react";
import {useHistory} from "react-router-dom";

type Props = {
    onPress?: () => void;
};

const PricingMenu: React.FC<Props> = ({onPress}) => {
    const history = useHistory();

    const handlePressListing = useCallback(
        (listing: Listing) => {
            onPress?.();
            history.push(`/pricing/${listing._id}`);
        },
        [history, onPress]
    );

    return (
        <VStack className="pt-4 lg:pt-0">
            <Text className="px-5" color="blueGray.800" variant="md">
                Listings
            </Text>
            <ListingsAndGroups className="lg:gap-0" onPressListing={handlePressListing} />
        </VStack>
    );
};

export default memo(PricingMenu);
